import {FieldInfoFormatConfiguration} from "../core/config/field-info-configuration";

export class FormatUtils {
    constructor() {}

    /**
     * Format a value based on format configuration
     */
    static formatValue(value: any, format: FieldInfoFormatConfiguration) {
        if (!format) {
            return value;
        }
        if (!value) {
            return "-";
        }
        if (format.places) {
            // use toString to remove insignificant trailing zeros
            value = (+value).toFixed(format.places).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, "$1");
        }
        if (format.digitSeparator) {
            value = Number(value).toLocaleString("de-CH");
        }
        if (format.dateFormat) {
            throw new Error("Not implemented.");
        }
        return value;
    }
    /**
    * Führende Zahlen im Title entfernen (Basemap Gallery)
    */
    static formatTitle(title: string) {
        return title.replace(/^(\d){2,3} /,"");
    }
    /**
     * Styling based on color variable
     *
     * @param value The value
     * @param colorVariable Color variable specifications
     * @param useColorVariableLabel Indicator whether the label of the color variable specification should be
     *                              displayed instead of the value
     */
    static visualFormat(value: number, colorVariable: __esri.ColorVariable, useColorVariableLabel: boolean) {
        for (let i = 0; i < colorVariable.stops.length; i++) {
            const stop = colorVariable.stops[i];
            if (value < stop.value) {
                return {
                    backgroundColor: stop.color,
                    colorLabel: stop.label,
                    textAlign: useColorVariableLabel ? "center" : "inherit"
                };
            }
        }
    }

    /**
     * Pad text with zeros
     *
     * @param text Input text
     * @param length The result length
     */
    static padZero(text: string, length: number | undefined | null) {
        length = length || 2;
        const zeros = new Array(length).join("0");
        return (zeros + text).slice(-length);
    }

    /**
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
     * @param regexString
     */
    static escapeRegExp(regexString: string): string {
        return regexString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
    }
    // https://stackoverflow.com/a/7760578
    // https://cheatsheetseries.owasp.org/cheatsheets/SQL_Injection_Prevention_Cheat_Sheet.html
    static encodeForSQL(str: string): string {
        return str.replace(/[\0\x08\x09\x1a\n\r"']/g, (char) => {
            switch (char) {
            case "\0":
            case "\x08":
            case "\x09":
            case "\x1a":
            case "\n":
            case "\r":
                return "";
            case "'":
                return "''";
            default:
                return char;
            }
        });
    }
    static encodeForSQLLike(str: string): string {
        str = this.encodeForSQL(str);
        return str.replace(/[_\\%]/g, (char) => {
            switch (char) {
            case "\\":
            case "%":
            case "_":
                return "\\"+char; // prepends a backslash to backslash, percent, and double/single quotes
            default:
                return char;
            }
        });
    }

}

